import { MenuList, Popover } from "@mui/material"

import getPosition from "./getPosition"
import type { ArrowType } from "./styles"
import { StyledArrow } from "./styles"

export default function MenuPopover({
  open,
  children,
  arrow = "top-right",
  disabledArrow,
  sx,
  onClose,
  ...other
}: {
  open: HTMLElement | null
  children: React.ReactNode
  arrow?: ArrowType
  disabledArrow?: boolean
  sx?: object
  onClose?: () => void
}) {
  const { style, anchorOrigin, transformOrigin } = getPosition(arrow)

  return (
    <Popover
      open={Boolean(open)}
      anchorEl={open}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      disableScrollLock={true}
      slotProps={{
        paper: {
          sx: {
            p: 1,
            width: "auto",
            overflow: "inherit",
            ...style,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
              "& svg": { mr: 2, width: 20, height: 20, flexShrink: 0 },
            },
            ...sx,
          },
        },
      }}
      onClose={onClose}
      {...other}
    >
      {!disabledArrow && <StyledArrow arrow={arrow} />}

      <MenuList autoFocusItem={Boolean(open)} disablePadding>
        {children}
      </MenuList>
    </Popover>
  )
}
